module.exports = __webpack_public_path__ + "static/media/answer_epod@2x.ca378967.png";